export default __webpack_public_path__ + "static/media/children.9d0ffb00.png";